import React from 'react';
import config from "../config";

const ColorIndicator = ({currentStatus}) => {

    const indicatorColorsMap = {
        [config.currentStatusMap.offline]: '#A4ADC1',
        [config.currentStatusMap.available]: '#00E3A6',
        [config.currentStatusMap.notHere]: '#E14E52',
        [config.currentStatusMap.pause]: '#e1984e',
    };

    return (
        <div style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: indicatorColorsMap[currentStatus || config.currentStatusMap.offline],
        }}/>);
};

export default ColorIndicator;


// WEBPACK FOOTER //
// ./src/components-new/ColorIndicator.jsx